import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import { formatDate } from '../../common/utils';
import Sources from '../../components/Reports/Sources';
import GreatnessTracker from '../../components/Reports/CORE/GreatnessTracker';
import LeadTracker from '../../components/Reports/CORE/LeadTracker';
import ReportsConversions from './conversions';
import ReportsSummary from './summary';
import LeaderboardIndividual from '../../components/Reports/Leaderboards/individual';
import LeaderboardTeam from '../../components/Reports/Leaderboards/team';
import LeaderboardCompany from '../../components/Reports/Leaderboards/company';
import Birthdays from '../../components/Reports/Birthdays';
import ReportsSidebarV2 from './sidebarV2';
import FunnelBarChart from '../../components/Reports/Charts/Bar/funnel';


const ReportsV2 = ( { aid, purpose, sources } ) => {
    let params = useParams();
    const [ reportType, setReportType ] = useState( params.rid || 'conversions' );
    const [ startDate, setStartDate ] = useState();
    const [ endDate, setEndDate ] = useState();
    const [ loanPurpose, setLoanPurpose ] = useState( '*' );
    const [ leadSource, setLeadSource ] = useState( '*' );
    const [ plist, setPList ] = useState( [] );
    const [ sourceList, setSourceList ] = useState( [] );
    const [ reportComponent, setReportComponent ] = useState();
    
    const renderReport = () => {
        const C = reportComponent;
        return ( C ) ? <C /> : null;
    }

    useEffect( () => {
        if ( purpose ) {
            setPList( purpose );
        }
    }, [ purpose ] );

    useEffect( () => {
        if ( sources ) {
            const list = [ ...sources ];
            list.sort();
            setSourceList( list );
        }
    }, [ sources ] );

    useEffect( () => {
        const options = {
            sources: Sources,
            conversions: ReportsConversions,
            summary: ReportsSummary,
            lbindividual: LeaderboardIndividual,
            lbteam: LeaderboardTeam,
            lbcompany: LeaderboardCompany,
            gt: GreatnessTracker,
            lt: LeadTracker,
            bday: Birthdays,
            funnel: FunnelBarChart
        };

        setReportComponent( options[reportType] );
    }, [ reportType ] );

    useEffect(() => {
        document.title = 'Third Floor - Reports';
    }, [] );

    return (
        <Container fluid className='p-0 tf-body-container'>
            <Row style={ { height: 'calc(100% - 15px)' } }>
                <ReportsSidebarV2 setReportType={setReportType} />
                <Col className='ps-0' md={10} style={ { height: '100%' } }>
                    {
                        renderReport()
                    }
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    purpose: state.user.meta.global.picklist.purpose,
    sources: state.user.meta.global.picklist.source
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( ReportsV2 );